import network from '@common/network/network';
import {uploader} from '@common/utils/uploader';
import {preload} from '@common/utils/utils.sources';
import moment from 'moment';

export default {
  getFamilyTreeLibraryFilteredAssetsChunkAction(context, {page}) {
    const params = {
      limit: context.state.assetsMeta.limit,
      offset: context.state.assetsMeta.limit * (page - 1),
      id: context.getters.libraryFamilyTreeIdState,
      order_by: context.getters.familyTreeAssetsOrderingState,
      ...context.getters.familyTreeLibraryFiltersAsStringsState,
    };
    return network.familyTreeLibrary.getAssets(params);
  },
  preloadNextFamilyTreeLibrarySrcsAction(context, {displayAssetId}) {
    const assets = context.getters.familyTreeLibraryAssetsState;
    const displayIndex = assets ? assets.findIndex(el => el.object_id === displayAssetId) : -1;
    if (displayIndex > -1 && assets.length > displayIndex + 1) {
      const srcList = [assets[displayIndex + 1].attachment];
      preload(srcList);
    }
  },
  fetchFamilyTreeLibraryAssetsAction(context, {familyTreeId, page, orderBy, ...filters}) {
    const limit = context.state.assetsMeta.limit;
    const offset = limit * (page - 1);

    context.commit('setFamilyTreeLibraryAssetsLoadingState', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .getAssets({id: familyTreeId, order_by: orderBy, limit, offset, ...filters})
        .then(response => {
          context.commit('setFamilyTreeLibraryAssetsState', response.objects);
          context.commit('setFamilyTreeLibraryAssetsMetaState', response.meta);
          if (response.meta.family_tree) {
            context.commit('setActiveFamilyTreeIdState', response.meta.family_tree.id);
          }
          resolve();
        })
        .catch(error => {
          if (parseInt(context.getters.activeFamilyTreeIdState) === parseInt(familyTreeId)) {
            context.commit('clearActiveFamilyTreeIdState');
          }
          reject(error);
        })
        .finally(() => {
          context.commit('setFamilyTreeLibraryAssetsLoadingState', false);
        });
    });
  },
  uploadFamilyTreeLibraryAssetAction(context, {familyTreeId, file, tagsData, tmpFileId}) {
    const id = tmpFileId || moment().unix() + '__' + file.lastModified + '__' + file.name;
    const fileData = {
      _id: id,
      progress: '0',
      error: false,
      uploading: true,
      attachment: '',
      filename: file.name,
      uploadingPreviewSrc: /image/g.test(file.type) ? URL.createObjectURL(new Blob([file])) : '',
    };
    context.commit('addToFamilyTreeLibraryAssetsState', fileData);

    return new Promise((resolve, reject) => {
      const progressCallback = value => {
        fileData.progress = Math.round(value).toString();
      };
      const rejectCallback = error => {
        fileData.error = true;
        fileData.uploading = false;
        reject(error);
      };
      const resolveCallback = response => {
        context.commit('onUploadFamilyTreeLibraryAssetState', {_id: id, error: false, uploading: false, ...response});
        resolve(response);
      };
      uploader.processFile(file, familyTreeId, tagsData, progressCallback, rejectCallback, resolveCallback);
    });
  },
  getFamilyTreeLibrarySearchOptionsAction(context, {familyTreeId, q, persons, locations, creators}) {
    context.commit('setFamilyTreeLibrarySearchOptionsLoadingState', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .getLibrarySearchOptions({id: familyTreeId, q, persons, locations, creators})
        .then(response => {
          context.commit('setFamilyTreeLibrarySearchOptionsState', response);
          resolve();
        })
        .finally(() => {
          context.commit('setFamilyTreeLibrarySearchOptionsLoadingState', false);
        });
    });
  },
  getAssetDetailsAction(context, {assetId}) {
    context.commit('setFamilyTreeAssetDetailsLoadingState', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .getAssetDetails({id: assetId})
        .then(response => {
          context.commit('mutateFamilyTreeAssetDetailsByIdState', response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          context.commit('setFamilyTreeAssetDetailsLoadingState', false);
        });
    });
  },
  assetRotateAction(context, {assetId, angle}) {
    return network.familyTreeLibrary.assetRotate({id: assetId, angle});
  },
  acceptAssetLocationSuggestionAction(context, {assetId}) {
    context.commit('setFamilyTreeAssetUpdateLoadingState', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .acceptLocationSuggestion({id: assetId})
        .then(response => {
          context.commit('mutateFamilyTreeAssetDetailsByIdState', {object_id: assetId, ...response});
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          context.commit('setFamilyTreeAssetUpdateLoadingState', false);
        });
    });
  },
  declineAssetLocationSuggestionAction(context, {assetId}) {
    context.commit('setFamilyTreeAssetUpdateLoadingState', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .declineLocationSuggestion({id: assetId})
        .then(response => {
          context.commit('mutateFamilyTreeAssetDetailsByIdState', {object_id: assetId, ...response});
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          context.commit('setFamilyTreeAssetUpdateLoadingState', false);
        });
    });
  },
  getProfileCropImageUrl(context, {assetId}) {
    context.commit('setProfileCropImageLoading', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .getAssetUrl({id: assetId})
        .then(response => {
          context.commit('mutateProfileCropImageUrl', response);
          resolve(response);
        })
        .finally(() => {
          context.commit('setProfileCropImageLoading', false);
        });
    });
  },
  patchAssetDetailsAction(context, {id, ...params}) {
    context.commit('setFamilyTreeAssetUpdateLoadingState', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .patchAsset({id, ...params})
        .then(response => {
          context.commit('mutateFamilyTreeAssetDetailsByIdState', {object_id: id, ...response});
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          context.commit('setFamilyTreeAssetUpdateLoadingState', false);
        });
    });
  },
  addPersonsToAssetsAction(context, {assets, personIds}) {
    context.commit('setFamilyTreeAssetUpdateLoadingState', true);
    for (let personId of personIds) {
      for (let asset of assets) {
        const photo = {
          _id: asset.object_id,
          object_id: asset.object_id,
          progress: '0',
          error: false,
          uploading: true,
          attachment: asset.attachment,
          filename: asset.filename,
          uploadingPreviewSrc: asset.thumbnail,
        };
        context.commit('addToFamilyTreePersonPhotoState', {id: personId, photo});
        context.commit('addToFamilyTreePersonFilesState', photo);
      }
    }
    const assetIds = assets.map(asset => asset.object_id);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .addPersonsToAssets({asset_ids: assetIds, person_ids: personIds})
        .then(response => {
          for (let personId of personIds) {
            for (let asset of assets) {
              context.commit('mutateFamilyTreePersonPhotoState', {
                id: personId,
                photoId: asset.object_id,
                uploading: false,
                uploadingPreviewSrc: null,
              });
              context.commit('mutatedFamilyTreePersonFileState', {
                _id: asset.object_id,
                uploading: false,
                uploadingPreviewSrc: null,
              });
            }
          }
          resolve(response);
        })
        .catch(error => {
          for (let personId of personIds) {
            for (let asset of assets) {
              context.commit('mutateFamilyTreePersonPhotoState', {
                id: personId,
                photoId: asset.object_id,
                uploading: false,
                error: true,
              });
            }
          }
          reject(error);
        })
        .finally(() => {
          context.commit('setFamilyTreeAssetUpdateLoadingState', false);
        });
    });
  },
  deleteAssetAction(context, assetId) {
    context.commit('setFamilyTreeAssetDeleteLoadingState', true);
    return new Promise((resolve, reject) => {
      network.familyTreeLibrary
        .deleteAsset({id: assetId})
        .then(() => {
          resolve();
        })
        .finally(() => {
          context.commit('setFamilyTreeAssetDeleteLoadingState', false);
        });
    });
  },
};
